import React from "react";
import "./statusbar.css";
const StatusBar = ({ values }) => {
  console.log(values, "val;");

  const options = [
    
    "Presentation",
    "Proposal",
    // "Negotiation",
    // "Contracting",
    "Closed Won",
    "SO Converted",
    "Closed Lost",
  ];

     const findtindex=options.indexOf(values?.stage)

     

  return (
    <div className="status-bar-box">
      <div className="status-box">
        {options.map((v, i) => {
          return (
            <div
              key={i}
              className={`status-text ${values?.stage=="Closed Lost" ? "status-close" : i <= findtindex ? "status-done":""} `}
            >
              <span>{v}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StatusBar;
